import React from 'react';
import classNames from 'classnames';
import pick from 'lodash/pick';

import { TranslatedField } from 'common/components/Form';
import TextInputRedux from 'common/components/Form/TextInputRedux';

import { LABEL_ADDRESS_1 } from '../messages';

import PlacesAutocomplete, {
  geocodeByAddress,
} from 'react-places-autocomplete';

export default class LocationSearchInput extends React.Component {
  static defaultProps = {
    geocodeByAddress,
    disabled: false,
    labelKey: LABEL_ADDRESS_1,
  };

  constructor(props) {
    super(props);
    this.state = {
      address: '',
      submittedAddress: '',
    };
  }

  componentDidMount() {
    if (this.props.initialValue) {
      this.setState({ address: this.props.initialValue });
    }
  }

  handleChange = address => {
    const _address = address.split(',')[0] || address;
    this.setState({ address: _address });
    this.props.onAddressSelect({ address1: _address });
  };

  handleSelect = submittedAddress => {
    this.setState({ submittedAddress });

    return this.props.geocodeByAddress(submittedAddress).then(results => {
      const formattedResults = this.geocodeResultToAddress(results);
      this.setState({ address: formattedResults.address1 });
      this.props.onAddressSelect(formattedResults);
      return results;
    });
  };

  handleError = (status, clearSuggestions) => {
    // there was an error with the submission,
    // wipe any results that may be shown
    // see: https://github.com/hibiken/react-places-autocomplete#onError
    clearSuggestions();
  };

  getCountry = components => {
    return components.find(component => component.types[0] === 'country')
      .short_name;
  };

  formatRoute = (street, number, country) => {
    // German addresses should have the number after the street name
    return country === 'DE' ? `${street} ${number}` : `${number} ${street}`;
  };

  geocodeResultToAddress = result => {
    const formattedResults = {};
    const components = result[0].address_components;
    const country = this.getCountry(result[0].address_components);

    components.forEach(item => {
      switch (item.types[0]) {
        case 'street_number':
          formattedResults.address1 = item.long_name;
          break;
        case 'route':
          formattedResults.address1 = formattedResults.address1
            ? this.formatRoute(
                item.long_name,
                formattedResults.address1,
                country
              )
            : item.long_name;
          break;
        case 'locality':
          formattedResults.city = item.long_name;
          break;
        case 'postal_town':
          formattedResults.city = item.long_name;
          break;
        case 'administrative_area_level_1':
          formattedResults.state = gon.CURRENT_COUNTRY_STATES.find(
            s => s.value === item.short_name
          );
          break;
        case 'postal_code':
          formattedResults.zipcode = item.long_name;
          break;
        default:
          break;
      }
    });
    return formattedResults;
  };

  renderAutocompleteMenuOption = (suggestion, getSuggestionItemProps) => {
    return (
      <div
        {...getSuggestionItemProps(suggestion, {
          className: suggestion.active
            ? 'Select-option is-focused'
            : 'Select-option',
        })}
      >
        <span>{suggestion.description}</span>
      </div>
    );
  };

  render() {
    const classes = {
      'Field__input Field__location-search-input': true,
      'Field__input--disabled': this.props.disabled,
    };

    return (
      <PlacesAutocomplete
        value={this.state.address}
        onChange={this.handleChange}
        onSelect={this.handleSelect}
        onError={this.handleError}
        searchOptions={{ types: ['address'] }}
        shouldFetchSuggestions={!!window.google}
        googleCallbackName="ageVerificationAddress"
      >
        {({ getInputProps, suggestions, getSuggestionItemProps }) => (
          <div className="Select__autocomplete-container">
            <TranslatedField
              {...getInputProps({
                className: classNames(classes),
                name: 'address1',
                labelText: this.props.labelKey,
                component: TextInputRedux,
                ...pick(this.props, ['disabled', 'maxLength']),
              })}
            />
            <div
              className={classNames('Select-menu Select-menu--autocomplete', {
                hide: !suggestions.length,
              })}
            >
              {suggestions.map(suggestion => {
                return this.renderAutocompleteMenuOption(
                  suggestion,
                  getSuggestionItemProps
                );
              })}
            </div>
          </div>
        )}
      </PlacesAutocomplete>
    );
  }
}
